import { QuoteCountyValidationState } from "./types";

export const defaultState = (): QuoteCountyValidationState => {
  return {
    editing: null,
    makingApiRequest: false,
    lastUpdate: new Date(),
    quoteCountyValidations: [],
    links: {}
  };
};

export const state = defaultState();
